export const startLoading = (imageWrapper: HTMLElement) => {
	if (!imageWrapper) return;
	imageWrapper.classList.add("is-deleting");

	const overlay = imageWrapper.querySelector(
		".processing-overlay",
	) as HTMLElement;

	if (!overlay) return;

	overlay.classList.add("is-loading");
};

export const stopLoading = (imageWrapper: HTMLElement) => {
	if (!imageWrapper) return;
	imageWrapper?.classList.remove("is-deleting");

	const overlay = imageWrapper.querySelector(
		".processing-overlay",
	) as HTMLElement;

	if (!overlay) return;

	overlay.classList.remove("is-loading");
};
